/**
 * IMPORTS
 */

import { authRepository } from "@/repositories/auth";

/**
 * Função que autentica usuário 🛠️.
 */
const handleAuthUser = async (email: string, senha: string) => {
  try {
    const data = await authRepository.authUser(email, senha);

    return data;
  } catch (error: unknown) {
    if (error instanceof Error) {
      throw error; // ou retorne uma estrutura com erro formatado
    }

    throw new Error("Erro desconhecido na autenticação");
  }
};

/**
 * Função que busca os dados do usuário autenticado 🛠️.
 */
const handleBuscarDadosUsuario = async (accessToken: string) => {
  const data = await authRepository.buscarDadosUsuario(accessToken);

  return data;
};

/**
 * EXPORTS
 */
export { handleAuthUser, handleBuscarDadosUsuario };
